module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/edabaf21efbdb886455e43629ab5b2f5.png";